(function (angular) {
	'use strict';

	angular.module('contactModule', [
		'apiModule',
		'coreModule',
		'formValidationModule',
		'googleRecaptchaModule',
		'vcRecaptcha'
	]);
})(window.angular);